<template>
  <div class="Subscribe-Content">
    <div class="Subscribe-Content__box">
      <div class="Subscribe-Content__ttl-box">
        <img class="Subscribe-Content__mindset" :src="mindset" height="40" width="40" alt="mindset" />
        <span class="Subscribe-Content__ttl">Эксклюзивно для Кэпиталистов</span>
      </div>
      <div class="Subscribe-Content__hdr-txt-box">
        <p class="Subscribe-Content__hdr-txt">
          Чтобы получить доступ ко всему Кэпиталу, держите PoN NFT на кошельке или выберите подписку на удобный срок:
        </p>
      </div>
      <div class="Subscribe-Content__subscribes">
        <SubscribeItem
          v-for="sub in subscriptions"
          :key="sub.id"
          :price="sub.price"
          :value="sub.value"
          :currency="sub.currency"
          :days="sub.days"
          :tag="sub.tag"
          :tagStyle="sub.tagStyle"
          :isPon="sub.isPon"
          :isActive="selectedId === sub.id"
          @click="selectSubscription(sub.id)"
        />
      </div>
      <div class="Subscribe-Content__benefits-box">
        <div class="Subscribe-Content__benefits">
          <SubscriptionBenefitsItem
            v-for="item in benefits" 
            class="Subscribe-Content__benefit"
            :title="item.title"
            :iconName="item.iconName"
            :text="item.description"
          />
        </div>
      </div>
    </div>
    <div v-if="selectedId" class="Subscribe-Content__actions">
      <template v-if="selectedId === 1">
        <div class="Subscribe-Content__actions-group">
          <ButtonMain :link="'https://opensea.io/collection/proof-of-narnian'" :type="'blue-border'" target="_blank" width="100%">
            Купить на OpenSea <LinkIcon class="Subscribe-Content__link-icon" />
          </ButtonMain>
          <ButtonMain class="Subscribe-Content__actions-group-btn" :link="'https://blur.io/eth/collection/proof-of-narnian-nft-og'" :type="'blue-border'" target="_blank" width="100%">
            Купить на Blur <LinkIcon class="Subscribe-Content__link-icon" />
          </ButtonMain>
        </div>
        <ButtonMain :type="'primary'" @click="goToBlur()" width="100%">
          Активировать PoN
        </ButtonMain>
      </template>
      <template v-else>
        <ButtonMain class="Subscribe-Content__actions-telegram" :type="'primary'" @click="startTelegramAuth" >
          {{ buttonText }}
        </ButtonMain>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
import { PATHS_NAME } from '@shared/routers/consts/pathsName.js';
import SubscribeItem from "./SubscribeItem/SubscribeItem.vue";
import ButtonMain from "@shared/UI/Buttons/ButtonMain/ButtonMain.vue";
import SubscriptionBenefitsItem from "./SubscriptionBenefitsItem/SubscriptionBenefitsItem.vue";
import LinkIcon from "@shared/UI/SVG/LinkIcon.vue";
import SubscribeStep from "./SubscribeStep/SubscribeStep.vue";
import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

const mindset = require("./icons/mindset.svg");

const store = useStore();
const router = useRouter();
const emit = defineEmits();

onMounted(() => {
  const currentId = sessionStorage.getItem('telegramWidgetCurrentID');
  if( currentId && sessionStorage.getItem('telegramWidgetLastOpened')){
    selectedId.value = parseInt(currentId);
  }
});

onBeforeUnmount(() => {
  sessionStorage.removeItem("isPonPageMove");
});

const subscriptions = [
  { 
    id: 1, 
    price: "0.34",
    value: "Разово", 
    currency: "ETH", 
    isPon: true, 
    link: "https://opensea.io/collection/proof-of-narnian",
    tagStyle: 'default' 
  },
  { 
    id: 2, 
    price: "239", 
    value: "19.9 $/мес", 
    additionalText: "Купить подписку на 12 месяцев",
    currency: "$", 
    days: "12", 
    tag: "экономия 44%", 
    tariff: "year", 
    tagStyle: 'primary' 
  },
  { 
    id: 3, 
    price: "59", 
    value: "29.5 $/мес", 
    additionalText: "Купить подписку на 2 месяцев",
    currency: "$", 
    days: "2", 
    tag: "экономия 22%", 
    tariff: "2months",
    tagStyle: 'secondary' 
  },
];

const benefits = [
  { iconName: 'alpha', title: 'Альфа', description: 'Анализ монет, обзоры проектов и идеи для заработка' },
  { iconName: 'podcasts', title: 'Подкасты', description: 'Три раза в неделю Сергей и команда обсуждают рынок, макро и жизнь' },
  { iconName: 'calendar', title: 'Календарь', description: 'Отслеживаем все важные события крипторынкаи мира' },
  { iconName: 'forecasters', title: 'Форкастеры', description: 'Топовые голоса твиттера с русским переводом и без впн' },
  { iconName: 'signal', title: 'Сигналы', description: 'Топовые голоса твиттера с русским переводом и без впн' },
  { iconName: 'chat', title: 'Чаты', description: 'Закрытые чаты в телеграме для нашего комьюнити' },
];

const selectedId = ref(2);

const buttonText = computed(() => {
  return `${selectedSubscription.value.additionalText || "Оформить подписку"}`
})

const selectSubscription = (id) => {
  sessionStorage.removeItem("isPonPageMove");
  selectedId.value = selectedId.value === id ? null : id;
  sessionStorage.setItem('telegramWidgetCurrentID', selectedSubscription.value ? selectedSubscription.value.id : null);
};

const userData = computed(() => store.state.UserSystem.user || {});
const hasTelegram = computed(() => Boolean(userData.value.telegram?.trim()));
const selectedSubscription = computed(() => subscriptions.find(s => s.id === selectedId.value) || {});
const isAuth = computed(() => store.getters['UserSystem/isAuthenticated']);

const createCryptoCloudPayment = async (tariff) => {
  const url = `${backendUrl}/api/payments/cryptocloud/create/`;
  const formData = new FormData();
  formData.append("tariff", tariff);

  try {
    const response = await fetchWithAuth(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) throw new Error("Ошибка при создании оплаты");

    const data = await response.json();
    console.log(data)
    console.log(data.pay_url)
    if(data?.pay_url) {
      window.open(data.pay_url, "_blank");
    } else {
      console.error("Не пришла ссылка оплаты");
    }
  } catch (err) {
    console.error("Ошибка Cryptocloud:", err);
  }
};

const goToBlur = () => {
  if (isAuth.value) {
    emit("close");
    router.push({ name: PATHS_NAME.USER.SUBSCRIPTION_PURCHASE });
  } else {
    toOpenAuth();
    sessionStorage.setItem("isPonPageMove", "true");
  }
};

const startTelegramAuth = async () => {
  if(!isAuth.value) {
    toOpenAuth();
    return;
  }

  // 🔹 Если подписка с tariff -> сразу делаем запрос в backend
  if(selectedSubscription.value.tariff){
    await createCryptoCloudPayment(selectedSubscription.value.tariff);
    return;
  }

  if(hasTelegram.value){
    window.open(selectedSubscription.value.link, '_blank');
  }

  const existingScript = document.getElementById("telegram-widget-script");
  if (!existingScript) {
    const script = document.createElement("script");
    script.id = "telegram-widget-script";
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    script.setAttribute("data-telegram-login", "DropsCapitalTest_bot");
    script.setAttribute("data-size", "large");
    script.setAttribute("data-auth-url", `${store.getters.getFrontendUrl}/telegram/link/callback/`);
    script.setAttribute("data-request-access", "write");
    document.body.appendChild(script);
  }
};

const toOpenAuth = () => {
  store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_LOGIN);
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.auth);
}
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>
